import { Component } from '@angular/core';
import { ButtonsComponent } from '../../checkout/buttons/buttons.component';

@Component({
  selector: 'lib-bulk-checkout-buttons',
  templateUrl: './bulk-checkout-buttons.component.html',
  styleUrls: ['./bulk-checkout-buttons.component.css'],
  standalone: false
})
export class BulkCheckoutButtonsComponent extends ButtonsComponent {}